import React, { Component } 	from 'react'
import { withStyles } 			from 'material-ui/styles'
import { get } 					from '../../services/apiServices'
import { token } 				from '../../services/authServices'
import { connect } 				from 'react-redux'
import { accountsAction,
		usersAction }		 	from '../../actions/contentActions'
import Accounts 				from '../content/Accounts'
import AccountContainer			from '../containers/AccountContainer'

const styles = {}

class AccountsContainer extends Component {

	toUsers = id => {
		let url = this.props.match.url

		this.props.history.push(`${url}${id}`)
	}

	locationListener = () => {
		/* if (this.props.match.params.id) {
			let AccountId = this.props.match.params.id

			this.props.initAccounts()
			.then(response => {
				this.getUsers(AccountId)
			})
		} else { this.props.initAccounts() } */

	}

	componentWillMount() {
		this.props.history.listen((obj, action) => {
			const isUsers = this.props.match.params ?
				this.props.match.params.id : false

			if((action == "POP" && isUsers)) {
				this.locationListener()
			}

		})
	}

	render() {
		const accountId = this.props.match.params ?
			this.props.match.params.id : false
		return (
			<div>
				{
					!accountId ?
					(
						<Accounts
							accounts={this.props.accounts}
							initAccounts={this.props.initAccounts}
							pageChange={this.props.accountsPageChange}
							toUsers={this.toUsers}
						/>
					) :
					(
						<AccountContainer
							accountId={accountId}
							match={this.props.match}
						/>
					)
				}
			</div>
		)
	}
}

AccountsContainer = connect(
	state => ({
		accounts: state.accounts,
		users: state.users
	}),
	dispatch => ({
		bridge          		: data => dispatch(data),
		initAccounts 			: data => dispatch(accountsAction(1)),
		accountsPageChange    	: page => dispatch(accountsAction(page)),
		initUsers 				: id => dispatch(usersAction(id)),
		usersPageChange 		: (id, page) => dispatch(usersAction(id, page))
	})
)(AccountsContainer);

export default withStyles(styles)(AccountsContainer);



// WEBPACK FOOTER //
// ./src/components/containers/AccountsContainer.js